/* tslint:disable */
/* eslint-disable */
/**
 * Client Signup API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { InvitationContextResponseEnterpriseCompany } from './';
import {
    InvitationContextResponseEnterpriseCompanyFromJSON,
    InvitationContextResponseEnterpriseCompanyFromJSONTyped,
    InvitationContextResponseEnterpriseCompanyToJSON,
} from './';
import type { InvitationContextResponseEnterpriseKpi } from './';
import {
    InvitationContextResponseEnterpriseKpiFromJSON,
    InvitationContextResponseEnterpriseKpiFromJSONTyped,
    InvitationContextResponseEnterpriseKpiToJSON,
} from './';
import type { InvitationContextResponseEnterpriseLogo } from './';
import {
    InvitationContextResponseEnterpriseLogoFromJSON,
    InvitationContextResponseEnterpriseLogoFromJSONTyped,
    InvitationContextResponseEnterpriseLogoToJSON,
} from './';
import type { InvitationContextResponseEnterpriseManagers } from './';
import {
    InvitationContextResponseEnterpriseManagersFromJSON,
    InvitationContextResponseEnterpriseManagersFromJSONTyped,
    InvitationContextResponseEnterpriseManagersToJSON,
} from './';
import type { InvitationContextResponseEnterpriseOrganization } from './';
import {
    InvitationContextResponseEnterpriseOrganizationFromJSON,
    InvitationContextResponseEnterpriseOrganizationFromJSONTyped,
    InvitationContextResponseEnterpriseOrganizationToJSON,
} from './';
import type { InvitationContextResponseEnterprisePoolOfFreelancers } from './';
import {
    InvitationContextResponseEnterprisePoolOfFreelancersFromJSON,
    InvitationContextResponseEnterprisePoolOfFreelancersFromJSONTyped,
    InvitationContextResponseEnterprisePoolOfFreelancersToJSON,
} from './';

/**
 * 
 * @export
 * @interface InvitationContextResponseEnterprise
 */
export interface InvitationContextResponseEnterprise {
    /**
     * 
     * @type {InvitationContextResponseEnterpriseManagers}
     * @memberof InvitationContextResponseEnterprise
     */
    managers?: InvitationContextResponseEnterpriseManagers;
    /**
     * 
     * @type {InvitationContextResponseEnterprisePoolOfFreelancers}
     * @memberof InvitationContextResponseEnterprise
     */
    poolOfFreelancers?: InvitationContextResponseEnterprisePoolOfFreelancers;
    /**
     * 
     * @type {InvitationContextResponseEnterpriseKpi}
     * @memberof InvitationContextResponseEnterprise
     */
    kpi?: InvitationContextResponseEnterpriseKpi;
    /**
     * The name of the company
     * @type {string}
     * @memberof InvitationContextResponseEnterprise
     */
    name?: string;
    /**
     * 
     * @type {InvitationContextResponseEnterpriseOrganization}
     * @memberof InvitationContextResponseEnterprise
     */
    organization?: InvitationContextResponseEnterpriseOrganization;
    /**
     * 
     * @type {InvitationContextResponseEnterpriseCompany}
     * @memberof InvitationContextResponseEnterprise
     */
    company?: InvitationContextResponseEnterpriseCompany;
    /**
     * 
     * @type {InvitationContextResponseEnterpriseLogo}
     * @memberof InvitationContextResponseEnterprise
     */
    logo?: InvitationContextResponseEnterpriseLogo;
}

/**
 * Check if a given object implements the InvitationContextResponseEnterprise interface.
 */
export function instanceOfInvitationContextResponseEnterprise(value: object): value is InvitationContextResponseEnterprise {
    return true;
}

export function InvitationContextResponseEnterpriseFromJSON(json: any): InvitationContextResponseEnterprise {
    return InvitationContextResponseEnterpriseFromJSONTyped(json, false);
}

export function InvitationContextResponseEnterpriseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvitationContextResponseEnterprise {
    if (json == null) {
        return json;
    }
    return {
        
        'managers': json['managers'] == null ? undefined : InvitationContextResponseEnterpriseManagersFromJSON(json['managers']),
        'poolOfFreelancers': json['poolOfFreelancers'] == null ? undefined : InvitationContextResponseEnterprisePoolOfFreelancersFromJSON(json['poolOfFreelancers']),
        'kpi': json['kpi'] == null ? undefined : InvitationContextResponseEnterpriseKpiFromJSON(json['kpi']),
        'name': json['name'] == null ? undefined : json['name'],
        'organization': json['organization'] == null ? undefined : InvitationContextResponseEnterpriseOrganizationFromJSON(json['organization']),
        'company': json['company'] == null ? undefined : InvitationContextResponseEnterpriseCompanyFromJSON(json['company']),
        'logo': json['logo'] == null ? undefined : InvitationContextResponseEnterpriseLogoFromJSON(json['logo']),
    };
}

export function InvitationContextResponseEnterpriseToJSON(value?: InvitationContextResponseEnterprise | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'managers': InvitationContextResponseEnterpriseManagersToJSON(value['managers']),
        'poolOfFreelancers': InvitationContextResponseEnterprisePoolOfFreelancersToJSON(value['poolOfFreelancers']),
        'kpi': InvitationContextResponseEnterpriseKpiToJSON(value['kpi']),
        'name': value['name'],
        'organization': InvitationContextResponseEnterpriseOrganizationToJSON(value['organization']),
        'company': InvitationContextResponseEnterpriseCompanyToJSON(value['company']),
        'logo': InvitationContextResponseEnterpriseLogoToJSON(value['logo']),
    };
}

